import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ForYou() {
  const points = ['Querés empezar a trabajar con deportistas y sentís que te falta estructura.', 'Ya atendés deportistas, pero tus sesiones a veces se vuelven conversaciones sueltas.', 'Te cuesta saber qué preguntar en la primera sesión.', 'Querés sentir más seguridad profesional al ofrecer servicios de psicología deportiva.'];
  return <section className="bg-white py-20 lg:py-28" data-id="element-86">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87">
        <div className="mx-auto max-w-4xl" data-id="element-88">
          <h2 className="mb-12 text-center text-3xl text-slate-900 md:text-4xl lg:text-5xl font-display" data-id="element-89">
            ESTE KIT ES PARA VOS SI...
          </h2>

          <div className="grid gap-4 md:grid-cols-2" data-id="element-90">
            {points.map((point, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.05
          }} className="flex items-start gap-4 rounded-2xl bg-slate-50 p-6 border border-slate-100" data-id="element-91">
                <CheckCircle2 className="h-6 w-6 shrink-0 text-emerald-500" data-id="element-92" />
                <p className="text-slate-700 font-medium" data-id="element-93">{point}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}